import { render, staticRenderFns } from "./OrderItemBlock.vue?vue&type=template&id=39eb0a80&scoped=true&"
import script from "./OrderItemBlock.vue?vue&type=script&lang=js&"
export * from "./OrderItemBlock.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemBlock.vue?vue&type=style&index=0&id=39eb0a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb0a80",
  null
  
)

export default component.exports